export const ATTENDANCE = 'ATTENDANCE';
export const SCHEDULED = 'SCHEDULED';

export const CHARGE_TYPES = [
    {
        data: ATTENDANCE,
        view: 'Actual Attendance'
    },
    {
        data: SCHEDULED,
        view: 'Scheduled Attendance'
    }
];


// WEBPACK FOOTER //
// ./src/constants/charge-types.js